<template>
  <div v-loading="loading"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0)"
    style="width: 100%; height: 100%;"></div>
</template>

<script>
export default {
  name: 'Loading',
  data () {
    return {
      loading: true
    }
  },
  mounted() {
    console.log(this.$route.query.key)
    this.lo()
  },
  methods: {
    lo (){
      setTimeout(() => {
        if (this.$route.query.key == 'NewDailyCab'){
          return window.open('https://viewer.ipaper.io/iveco-hq/uk/Daily-Cab/','_blank')
        }
        if (this.$route.query.key == 'NewDailyVan') {
          return window.open('https://viewer.ipaper.io/iveco-hq/uk/Daily-Van/','_blank')
        }
      }, 1000)
    }
  }
}
</script>

<style>
  html,body {
    height: 100%;
  }
  .el-loading-spinner i {
    font-size: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/404.vue